var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Network =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(settings, cache) {
      _classCallCheck(this, _class);

      this.Cache = cache;

      if (settings.hasOwnProperty("DedicatedServer")) {
        this.DedicatedServer = new global.Server(settings["DedicatedServer"]);
        return;
      }

      throw new Error("Bad network settings");
    }

    _createClass(_class, [{
      key: "search_manifest",
      value: function () {
        var _search_manifest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(manifest) {
          var result, dois, doi, search_result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "Not found",
                    source: null,
                    data: null
                  };
                  dois = manifest.get_doi();

                  if (!(0 === dois.data.length)) {
                    _context.next = 5;
                    break;
                  }

                  result.status = "Manifest has no doi";
                  return _context.abrupt("return", result);

                case 5:
                  if (!this.DedicatedServer) {
                    _context.next = 22;
                    break;
                  }

                  _context.t0 = _regeneratorRuntime.keys(dois.data);

                case 7:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 22;
                    break;
                  }

                  doi = _context.t1.value;
                  _context.next = 11;
                  return this.search_manifest_by_doi(dois.data[doi]);

                case 11:
                  search_result = _context.sent;

                  if (!("ok" === search_result.status)) {
                    _context.next = 19;
                    break;
                  }

                  result.status = "ok";
                  result.source = search_result.source;
                  result.data = search_result.data;
                  return _context.abrupt("return", result);

                case 19:
                  result.status = search_result.status;

                case 20:
                  _context.next = 7;
                  break;

                case 22:
                  return _context.abrupt("return", result);

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function search_manifest(_x) {
          return _search_manifest.apply(this, arguments);
        }

        return search_manifest;
      }()
    }, {
      key: "search_manifest_by_doi",
      value: function () {
        var _search_manifest_by_doi = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(doi) {
          var result, manifest, json_manifest, _manifest;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = {
                    status: "",
                    source: null,
                    data: null
                  };

                  if (!("" == doi)) {
                    _context2.next = 4;
                    break;
                  }

                  result.status = "Empty doi";
                  return _context2.abrupt("return", result);

                case 4:
                  if (!this.DedicatedServer) {
                    _context2.next = 18;
                    break;
                  }

                  manifest = this.Cache.get_manifest_by_doi(doi);

                  if (!("ok" === manifest.status)) {
                    _context2.next = 12;
                    break;
                  }

                  result.status = "ok";
                  result.source = "Cache";
                  result.data = manifest.data;
                  _context2.next = 16;
                  break;

                case 12:
                  _context2.next = 14;
                  return this.DedicatedServer.get_manifest_by_doi(doi);

                case 14:
                  json_manifest = _context2.sent;

                  if ("ok" === json_manifest.status) {
                    try {
                      _manifest = new global.Manifest(json_manifest.data);
                      result.status = "ok";
                      result.source = "Network";
                      result.data = _manifest;
                      this.Cache.set_manifest_by_doi(_manifest, doi);
                    } catch (error) {
                      result.status = "Not valid manifest (" + error + ")";
                    }
                  } else {
                    result.status = json_manifest.status;
                  }

                case 16:
                  _context2.next = 19;
                  break;

                case 18:
                  result.status = "Not implimented";

                case 19:
                  return _context2.abrupt("return", result);

                case 20:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function search_manifest_by_doi(_x2) {
          return _search_manifest_by_doi.apply(this, arguments);
        }

        return search_manifest_by_doi;
      }()
    }, {
      key: "search_data",
      value: function () {
        var _search_data = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(manifest) {
          var result, dois, doi, search_result;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  result = {
                    status: "Not found",
                    source: null,
                    data: null
                  };
                  dois = manifest.get_doi();

                  if (!(0 === dois.data.length)) {
                    _context3.next = 5;
                    break;
                  }

                  result.status = "Manifest has no doi";
                  return _context3.abrupt("return", result);

                case 5:
                  if (!this.DedicatedServer) {
                    _context3.next = 22;
                    break;
                  }

                  _context3.t0 = _regeneratorRuntime.keys(dois.data);

                case 7:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 22;
                    break;
                  }

                  doi = _context3.t1.value;
                  _context3.next = 11;
                  return this.search_data_by_doi(dois.data[doi]);

                case 11:
                  search_result = _context3.sent;

                  if (!("ok" === search_result.status)) {
                    _context3.next = 19;
                    break;
                  }

                  result.status = "ok";
                  result.source = search_result.source;
                  result.data = search_result.data;
                  return _context3.abrupt("return", result);

                case 19:
                  result.status = search_result.status;

                case 20:
                  _context3.next = 7;
                  break;

                case 22:
                  return _context3.abrupt("return", result);

                case 23:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function search_data(_x3) {
          return _search_data.apply(this, arguments);
        }

        return search_data;
      }()
    }, {
      key: "search_data_by_doi",
      value: function () {
        var _search_data_by_doi = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(doi) {
          var result, data, server_data;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  result = {
                    status: "",
                    source: null,
                    data: null
                  };

                  if (!this.DedicatedServer) {
                    _context4.next = 22;
                    break;
                  }

                  data = this.Cache.get_data_by_doi(doi);

                  if (!("ok" === data.status)) {
                    _context4.next = 8;
                    break;
                  }

                  result.status = "ok";
                  result.source = "Cache";
                  result.data = data.data;
                  return _context4.abrupt("return", result);

                case 8:
                  _context4.next = 10;
                  return this.DedicatedServer.get_data_by_doi(doi);

                case 10:
                  server_data = _context4.sent;

                  if (!("ok" === server_data.status)) {
                    _context4.next = 19;
                    break;
                  }

                  result.status = "ok";
                  result.source = "Network";
                  result.data = server_data.data;
                  this.Cache.set_data_by_doi(server_data.data, doi);
                  return _context4.abrupt("return", result);

                case 19:
                  result.status = server_data.status;

                case 20:
                  _context4.next = 23;
                  break;

                case 22:
                  result.status = "Not implimented";

                case 23:
                  return _context4.abrupt("return", result);

                case 24:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function search_data_by_doi(_x4) {
          return _search_data_by_doi.apply(this, arguments);
        }

        return search_data_by_doi;
      }()
    }]);

    return _class;
  }();
})();